'use client'

import { sortSizesFromObjects } from '@/lib/helpers/sort-size.helper'
import { VariantMapped } from '@/types/product'
import { ArrowRight, Plus } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useMemo } from 'react'
import { useProductCardContext } from '../context/product-card-context'
import { ProductCardSizeItem } from './size-item'

export const ProductItemSizes = () => {
  const { selectedColorVariant, product, handleAddToCart } =
    useProductCardContext()

  const handleAddToCartEvent = (variant: VariantMapped) => {
    handleAddToCart(variant)
  }
  const t = useTranslations('product_detail.button')

  const sizeOptions = useMemo(
    () =>
      sortSizesFromObjects<VariantMapped>(
        selectedColorVariant?.variants || [],
        'size'
      ),
    [selectedColorVariant]
  )
  const isOnlyOneSize = sizeOptions?.length === 1 && !sizeOptions[0].size

  if (product.is_combo) return <ViewDetail href={product.href} />

  if (isOnlyOneSize)
    return <QuickAdd onAdd={() => handleAddToCartEvent(sizeOptions[0])} />

  return (
    <div className='invisible absolute bottom-2 left-2 z-[2] w-[calc(100%-16px)] translate-y-3 rounded-lg bg-light/20 px-5 py-2 opacity-0 backdrop-blur-[35px] transition-all duration-300 hover:visible group-hover:visible group-hover:translate-y-0 group-hover:opacity-100 lg:py-3 2xl:px-6'>
      <div
        className='mb-2 flex items-center justify-center gap-1 whitespace-nowrap font-criteria text-xs font-medium text-neutral-800'
        data-tracking-level-100={`Product-item-${product.id}-Thêm_nhanh_vào_giỏ_hàng`}
      >
        {/* 2xl:text-sm */}
        {t('quick_add_to_cart')} <Plus size={16} className='min-h-4 min-w-4' />
      </div>
      <ul className='flex flex-wrap items-center gap-1'>
        {sizeOptions?.map((variant, index) => (
          <ProductCardSizeItem
            title={variant.size}
            key={index}
            isDisable={variant.isDisable}
            onClick={() => handleAddToCartEvent(variant)}
            id={variant.id}
          />
        ))}
      </ul>
    </div>
  )
}

const QuickAdd = ({ onAdd }: { onAdd: () => void }) => {
  const t = useTranslations('product_detail.button')

  return (
    <button
      className='absolute bottom-2 left-2 z-[2] flex w-[calc(100%-16px)] items-center justify-center gap-1 whitespace-nowrap rounded-lg bg-light p-4 font-criteria text-sm font-medium text-neutral-800 opacity-0 backdrop-blur-[35px] transition-all duration-300 hover:bg-neutral-100 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100 md:px-4 md:py-3 md:text-xs 2xl:px-5 2xl:py-6 2xl:text-base'
      onClick={onAdd}
    >
      {t('quick_add_to_cart')} <Plus size={16} />
    </button>
  )
}

const ViewDetail = ({ href }: { href: string }) => {
  const t = useTranslations('button')
  return (
    <Link
      href={href}
      className='group absolute bottom-2 left-2 z-[2] flex w-[calc(100%-16px)] items-center justify-center gap-1 rounded-lg bg-light p-4 font-criteria text-sm font-medium text-neutral-800 opacity-0 backdrop-blur-[35px] transition-all duration-300 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100 lg:px-5 lg:py-6 lg:text-base'
    >
      {t('view_detail')}{' '}
      <ArrowRight
        size={16}
        className='transition-transform duration-300 group-hover:translate-x-1'
      />
    </Link>
  )
}
